import React, { Component, Fragment } from 'react';
import { FormSpy } from 'react-final-form';
import { asyncConnect } from 'react-async-client';
import { path } from 'ramda';

import {
    metroHRGeneralist,
    metroHRBP,
    metroHRM,
    metroHRBPOperations,
} from 'constants/dictionaries';
import {
    METRO_REQUEST_MGL,
    METRO_REQUEST_STORE,
    METRO_REQUEST_HQ,
    METRO_REQUEST_ROUTES_FILTERS,
} from 'constants/metro';
import { getDictionaryUrl } from 'constants/urls';
import { getMetroPosition, getMetroFunction, getMetroCost, getMetroChief, getFieldDictionary } from 'actions/asyncActions';

const isMGL = props => props.routeType === METRO_REQUEST_MGL;

const CellFieldsSetter = asyncConnect({
    getMetroPosition: getMetroPosition
        .withSuccessHandler(({ setPosition }, action) => setPosition(action.payload))
        .withPayload(({ cell, city, routeType }) => cell ? ({ id: cell, city, routeType }) : null)
        .withOptions({ dispatchOnUpdate: true }),
})(() => null);

const CostFieldsSetter = asyncConnect({
    getMetroCost: getMetroCost
        .withSuccessHandler(({ setPCC }, action) => setPCC(action.payload))
        .withPayload(({ type, departmID }) => type && departmID ? ({ type, departmID }) : null)
        .withOptions({ dispatchOnUpdate: true }),
})(() => null);

const FunctionFieldsSetter = asyncConnect({
    getMetroFunction: getMetroFunction
        .withSuccessHandler(({ setFunction }, action) => setFunction(action.payload))
        .withPayload(({ type, departmID }) => type && departmID ? ({ type, departmID }) : null)
        .withOptions({ dispatchOnUpdate: true }),
})(() => null);

const ChiefSetter = asyncConnect({
    getMetroChief: getMetroChief
        .withSuccessHandler(({ setChief }, action) => setChief(action.payload))
        .withPayload(({ departmID, replace, type }) => departmID && type ? ({ id: departmID, type, replace }) : null)
        .withOptions({ dispatchOnUpdate: true }),
})(() => null);

const getHRM = props => props.storeCode ? getDictionaryUrl({
    loadName: metroHRM,
    params: {
        addCode: props.storeCode,
    }
}) : null;
const HRMSetter = asyncConnect({
    getFieldDictionary: getFieldDictionary
        .withSuccessHandler(({ setHRM }, action) => setHRM(action.payload))
        .withPayload(getHRM)
        .withParams(getHRM)
        .withOptions({ dispatchOnUpdate: true }),
})(() => null);

const getHRGeneralist = props => isMGL(props) || props.directorateEngl ? getDictionaryUrl({
    loadName: metroHRGeneralist,
    params: {
        type: METRO_REQUEST_ROUTES_FILTERS[props.routeType],
        URLEncfuncOrRegion: props.directorateEngl,
    }
}) : null;
const HRGeneralistSetter = asyncConnect({
    getFieldDictionary: getFieldDictionary
        .withSuccessHandler(({ setHRGeneralist }, action) => setHRGeneralist(action.payload))
        .withPayload(getHRGeneralist)
        .withParams(getHRGeneralist)
        .withOptions({ dispatchOnUpdate: true }),
})(() => null);

const getHRBP = props => isMGL(props) || (props.region || props.directorateEngl) ? getDictionaryUrl({
    loadName: metroHRBP,
    params: {
        type: METRO_REQUEST_ROUTES_FILTERS[props.routeType],
        URLEncfuncOrRegion: props.routeType === METRO_REQUEST_STORE ? props.region : props.directorateEngl
    }
}) : null;
const HRBPSetter = asyncConnect({
    getFieldDictionary: getFieldDictionary
        .withSuccessHandler(({ setHRBP }, action) => setHRBP(action.payload))
        .withPayload(getHRBP)
        .withParams(getHRBP)
        .withOptions({ dispatchOnUpdate: true }),
})(() => null);

const getHRBPOperations = props => props.storeCode ? getDictionaryUrl({
    loadName: metroHRBPOperations,
    params: {
        addCode: props.storeCode,
        URLEncfuncOrRegion: props.region
    }
}) : null;
const HRBPOperationsSetter = asyncConnect({
    getFieldDictionary: getFieldDictionary
        .withSuccessHandler(({ setHRBPOperations }, action) => setHRBPOperations(action.payload))
        .withPayload(getHRBPOperations)
        .withParams(getHRBPOperations)
        .withOptions({ dispatchOnUpdate: true }),
})(() => null);

export default class TypeFields extends Component {
    setChief = item => {
        if (item) {
            const { change, batch } = this.props.form;

            batch(() => {
                change('chief', item.chief);
                change('chiefEngl', item.chief);
                change('chiefCode', item.key);
                change('chiefPosition', item.chiefPosition);
                change('chiefPositionEngl', item.chiefPosition);
                change('chiefPositionCode', item.chiefPositionCode);
            });
        }
    }

    setFunction = value => {
        const { change } = this.props.form;

        change('function', value.funcCode);
    }

    setPCC = value => {
        const { change } = this.props.form;

        change('positionCostCenters', value.mvz);
    }

    setHRField = (dict, valueName, valueField = 'id') => {
        const { change } = this.props.form;
        const value = path([0, valueField], dict);

        change(valueName, value);
    }

    render() {
        return (
            <FormSpy subscribtions={['values']}>
                { ({ values }) => (
                    <Fragment>
                        <CellFieldsSetter
                            cell={values.cellId}
                            city={values.city}
                            routeType={values.routeType}
                            setPosition={this.props.setPosition}
                        />
                        <CostFieldsSetter
                            type={METRO_REQUEST_ROUTES_FILTERS[values.routeType]}
                            departmID={values.departmentCode}
                            setPCC={this.setPCC}
                        />
                        <FunctionFieldsSetter
                            type={METRO_REQUEST_ROUTES_FILTERS[values.routeType]}
                            departmID={values.departmentCode}
                            setFunction={this.setFunction}
                        />
                        <ChiefSetter
                            type={METRO_REQUEST_ROUTES_FILTERS[values.routeType]}
                            departmID={values.departmentCode}
                            replace={values.displacedEmployeePid}
                            setChief={this.setChief}
                        />

                        { values.routeType === METRO_REQUEST_STORE ? (
                            <Fragment>
                                <HRMSetter
                                    setHRM={dict => {
                                        this.setHRField(dict, 'HRGeneralistCode');
                                        if (values.routeType !== METRO_REQUEST_HQ) {
                                            this.setHRField(dict, 'recruiterCode');
                                            this.setHRField(dict, 'recruiter', 'name');
                                        }
                                    }}
                                    storeCode={values.storeCode}
                                />
                                <HRBPOperationsSetter
                                    setHRBPOperations={dict => {
                                        this.setHRField(dict, 'HRBPOperationsCode');
                                    }}
                                    storeCode={values.storeCode}
                                    region={values.region}
                                />
                            </Fragment>
                        ) : (
                            <HRGeneralistSetter
                                setHRGeneralist={dict => {
                                    this.setHRField(dict, 'HRGeneralistCode');
                                    if (values.routeType !== METRO_REQUEST_HQ) {
                                        this.setHRField(dict, 'recruiterCode');
                                        this.setHRField(dict, 'recruiter', 'name');
                                    }
                                }}
                                routeType={values.routeType}
                                region={values.region}
                                directorateEngl={values.directorateEngl}
                            />
                        )}

                        <HRBPSetter
                            setHRBP={dict => this.setHRField(dict, 'HRBPCode')}
                            routeType={values.routeType}
                            directorateEngl={values.directorateEngl}
                            region={values.region}
                        />
                    </Fragment>
                )}
            </FormSpy>
        );
    }
}
